import React, { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";

const Layout = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    const handleLogoutComplete = () => {
      navigate('/login', { replace: true });
    };
    
    const handleTokenExpired = () => {
      navigate('/login', { replace: true });
    };
    
    const handleNavigateToDashboard = () => {
      navigate('/', { replace: true });
    };
    
    window.addEventListener('logout-complete', handleLogoutComplete);
    window.addEventListener('token-expired', handleTokenExpired);
    window.addEventListener('navigate-to-dashboard', handleNavigateToDashboard);
    
    return () => {
      window.removeEventListener('logout-complete', handleLogoutComplete);
      window.removeEventListener('token-expired', handleTokenExpired);
      window.removeEventListener('navigate-to-dashboard', handleNavigateToDashboard);
    };
  }, [navigate]);

  return (
    <div className="App">
      <Sidebar />
      <div className="main-content">
        <Header />
        <Outlet />
      </div>
    </div>
  );
};

export default Layout;